import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { Index, Configure } from 'react-instantsearch';
import DesktopOnly from 'components/consumer/DesktopOnly';
import useAllOptions from 'data-hooks/useAllOptions';
import StaticProductResults from '../../instant-search/components/StaticProductResults';
import SearchDesktopSidebarHeader from './SearchDesktopSidebarHeader';
const SearchProductsContent = t0 => {
  const $ = _c(37);
  const {
    colorFiltered,
    hitsPerPage,
    inactive,
    indexName,
    invalidProductIds,
    onIndexChange,
    onSortOrderChange,
    onToggleQuickshipFilter,
    resetAlgoliaFilters,
    removeProductIdFromList,
    searchState,
    searchStateQuery,
    setActiveAlgoliaFilter,
    setInactive,
    sortOrder,
    toggleIsSearchOpen,
    updateInvalidProductIds,
    loadRest
  } = t0;
  const [productsLoading, setProductsLoading] = useState(false);
  const [lastQuery, setLastQuery] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [lastQueryTopThreeRes, setLastQueryTopThreeRes] = useState(t1);
  const allOptionsData = useAllOptions();
  const t2 = searchState.configure?.facetFilters || "";
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["item_availability<2", "visibility>0", "visibility<4"];
    t4 = ["_highlightResult", "product_id", "name", "is_in_stock"];
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] !== hitsPerPage || $[4] !== searchStateQuery || $[5] !== t2) {
    t5 = <Configure query={searchStateQuery} hitsPerPage={hitsPerPage} facetFilters={t2} numericFilters={t3} attributesToRetrieve={t4} />;
    $[3] = hitsPerPage;
    $[4] = searchStateQuery;
    $[5] = t2;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== indexName || $[8] !== onIndexChange || $[9] !== searchState) {
    t6 = <DesktopOnly><SearchDesktopSidebarHeader index={indexName} onIndexChange={onIndexChange} searchState={searchState} /></DesktopOnly>;
    $[7] = indexName;
    $[8] = onIndexChange;
    $[9] = searchState;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== allOptionsData || $[12] !== colorFiltered || $[13] !== hitsPerPage || $[14] !== inactive || $[15] !== invalidProductIds || $[16] !== lastQuery || $[17] !== lastQueryTopThreeRes || $[18] !== loadRest || $[19] !== onSortOrderChange || $[20] !== onToggleQuickshipFilter || $[21] !== productsLoading || $[22] !== removeProductIdFromList || $[23] !== resetAlgoliaFilters || $[24] !== searchState || $[25] !== searchStateQuery || $[26] !== setActiveAlgoliaFilter || $[27] !== setInactive || $[28] !== sortOrder || $[29] !== t6 || $[30] !== toggleIsSearchOpen || $[31] !== updateInvalidProductIds) {
    t7 = <StaticProductResults allOptionsData={allOptionsData} attribute="type" colorFiltered={colorFiltered} inactive={inactive} invalidProductIds={invalidProductIds} lastQuery={lastQuery} lastQueryTopThreeRes={lastQueryTopThreeRes} layout="minimal" limit={500} loadingMore={productsLoading} onSortOrderChange={onSortOrderChange} onToggleQuickshipFilter={onToggleQuickshipFilter} optionState="allOpts" removeProductIdFromList={removeProductIdFromList} resetAlgoliaFilters={resetAlgoliaFilters} searchState={searchState} searchStateQuery={searchStateQuery} setActiveAlgoliaFilter={setActiveAlgoliaFilter} setInactive={setInactive} setLastQuery={setLastQuery} setLastQueryTopThreeRes={setLastQueryTopThreeRes} setLoading={setProductsLoading} loadRest={loadRest} hitsPerPage={hitsPerPage} sidebarHeader={t6} sortOrder={sortOrder} toggleSearchOpen={toggleIsSearchOpen} updateInvalidProductIds={updateInvalidProductIds} variant="advanced-search" />;
    $[11] = allOptionsData;
    $[12] = colorFiltered;
    $[13] = hitsPerPage;
    $[14] = inactive;
    $[15] = invalidProductIds;
    $[16] = lastQuery;
    $[17] = lastQueryTopThreeRes;
    $[18] = loadRest;
    $[19] = onSortOrderChange;
    $[20] = onToggleQuickshipFilter;
    $[21] = productsLoading;
    $[22] = removeProductIdFromList;
    $[23] = resetAlgoliaFilters;
    $[24] = searchState;
    $[25] = searchStateQuery;
    $[26] = setActiveAlgoliaFilter;
    $[27] = setInactive;
    $[28] = sortOrder;
    $[29] = t6;
    $[30] = toggleIsSearchOpen;
    $[31] = updateInvalidProductIds;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  let t8;
  if ($[33] !== indexName || $[34] !== t5 || $[35] !== t7) {
    t8 = <Index indexName={indexName}>{t5}{t7}</Index>;
    $[33] = indexName;
    $[34] = t5;
    $[35] = t7;
    $[36] = t8;
  } else {
    t8 = $[36];
  }
  return t8;
};
export default SearchProductsContent;